// Packages
import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

// Components
import FormTemplate from 'components/BTDUI/FormTemplate';
import BTDTextField from 'components/BTDUI/fields/BTDTextField';
import BTDButton from 'components/BTDUI/BTDButton';

const ProcedureForm = ({ errors, procedure, onClose, onSubmit, type, }) => {

    const [data, setData] = useState({})
	const [changedData, setChangedData] = useState({})
    

    // Load Item values into form
	useEffect(() => {

		if ( procedure )
		{
            setData(procedure);
		}

	}, [procedure]);


    return(
        <FormTemplate onClose={() => {onClose()}}>

            <h3 className="form__title medium">{type === 'create' ? 'Create procedure' : 'Edit procedure'}</h3>

            <BTDTextField
                error={errors && errors.number ? errors.number : null} 
                label='Number'
                onChange={(value) => {
                    setData({...data, number: value});
                    setChangedData({...changedData, number: value});
                }} 
                required={true}
                tabIndex={1}
                value={data.number ?? ''} 
            />

            <BTDTextField
                error={errors && errors.name ? errors.name : null} 
                label='Name'
                onChange={(value) => {
                    setData({...data, name: value});
                    setChangedData({...changedData, name: value});
                }} 
                required={true}
                tabIndex={1}
                value={data.name ?? ''} 
            />

            <BTDButton 
                formButton={true}
                label={type === 'create' ? 'Save procedure' : 'Update procedure'}
                onClick={() => {onSubmit(changedData)}} 
            ></BTDButton>

        </FormTemplate>
    )

}

ProcedureForm.propTypes = {
	errors: PropTypes.object,
	procedure: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    onClose: PropTypes.func,
	onSubmit: PropTypes.func,
    type: PropTypes.string
}

ProcedureForm.defaultProps = {
    errors: {},
    procedure: null,
	onSubmit: () => {alert('onSubmit is not set')},
	onClose: () => {alert('onClose is not set')},
    type: 'create'
}

export default ProcedureForm;